/* ============================================================
   kevlts - Maison - interactions
   Lightweight, dependency-free. Currently powers scroll reveals
   for the custom kevlts homepage sections (.kv-reveal).
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  function initReveals(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.kv-reveal:not(.is-in)');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAll(els);
      return;
    }

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- showcase product rotator ---------- */
  function initShowcase(root) {
    var scope = root || document;
    var blocks = scope.querySelectorAll('[data-kv-showcase]');
    blocks.forEach(function (el) {
      if (el.__kvInit) return;
      el.__kvInit = true;

      var slides = el.querySelectorAll('.kv-pslide');
      var dots = el.querySelectorAll('[data-dot]');
      if (slides.length < 2) return;

      var current = 0;
      var delay = parseInt(el.getAttribute('data-autoplay'), 10) || 0;
      var timer = null;

      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-on', idx === current); });
      }

      function play() {
        if (!delay || reduceMotion) return;
        stop();
        timer = setInterval(function () { show(current + 1); }, delay * 1000);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          show(parseInt(d.getAttribute('data-dot'), 10));
          play();
        });
      });

      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', play);

      show(0);
      play();
    });
  }

  function boot() { initReveals(document); initShowcase(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-scan when sections are re-rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    initShowcase(e.target);
  });
})();
